import { STATE_PROP } from '../util/constant';

export const selectReducer = (state) => state[STATE_PROP];

export const selectCleaningTaskCompletionInfo = (state) => {
  return selectReducer(state) ? selectReducer(state).get('list') : {};
};
